import { render } from "./ArtistMobileSidebar.vue?vue&type=template&id=3b47d744"
import script from "./ArtistMobileSidebar.vue?vue&type=script&lang=js"
export * from "./ArtistMobileSidebar.vue?vue&type=script&lang=js"

import "./ArtistMobileSidebar.vue?vue&type=style&index=0&id=3b47d744&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__